/**
 * File: productsPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v3.2.1
 * Created: 2025-12-04
 * Last Updated: 2026-07-26
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { routes } from "../../constants/routes";
import GridCard from "../../components/ui/GridCard";

// Products Page
export const productsPage = {
    meta: {
        id: "products-page",
    },
    hero: {
        image: "./svgs/products_hero_abstract-lines.svg",
        headline:
            "Powerful Tools to Streamline Every Part of Your MEP Workflow",
        subheadline:
            "Scale your team, automate calculations, create schedules, and improve QA/QC - all with purpose-built products designed for mechanical and plumbing professionals.",
        primaryButton: {
            text: "Request Access",
            type: "primary",
        },
        secondaryButton: {
            text: "Send Inquiry",
            type: "secondary",
        },
    },
    gridItems: [
        {
            id: "tecthub",
            component: GridCard,
            props: {
                header: "TECTHUB",
                subheader: "On-demand project talent",
                description:
                    "Quickly scale your team with vetted mechanical and plumbing consultants for any project phase.",
                buttonText: "Learn More",
                buttonLink: routes.public.products.root,
                image: "./svgs/products_tecthub_person-network.svg",
                icon: "./svgs/dropdown_products_tecthub-icon.svg",
                tagLabel: "COMING SOON",
            },
            modifier: "grid-item--column-span-2",
        },
        {
            id: "flowkit",
            component: GridCard,
            props: {
                header: "FLOWKIT",
                subheader: "Essential design calculations",
                description:
                    "Access a comprehensive suite of HVAC and plumbing tools built for accurate, code-compliant results.",
                buttonText: "Learn More",
                buttonLink: routes.public.products.root,
                image: "./svgs/products_flowkit_digital-buildings.svg",
                icon: "./svgs/dropdown_products_flowkit-icon.svg",
                tagLabel: "COMING SOON",
            },
            modifier: "grid-item--row-span-2",
        },
        {
            id: "nameplate",
            component: GridCard,
            props: {
                header: "NAMEPLATE",
                subheader: "Automated project schedules",
                description:
                    "Generate equipment schedules and streamline coordination with built-in templates.",
                buttonText: "Learn More",
                buttonLink: routes.public.products.root,
                image: "./svgs/products_nameplate_gear-report.svg",
                icon: "./svgs/dropdown_products_nameplate-icon.svg",
                tagLabel: "COMING SOON",
            },
            modifier: null,
        },
        {
            id: "isocheck",
            component: GridCard,
            props: {
                header: "ISOCHECK",
                subheader: "Smarter QA/QC workflows",
                description:
                    "Automate design reviews and track comments in one place to improve quality and team efficiency.",
                buttonText: "Learn More",
                buttonLink: routes.public.products.root,
                image: "./svgs/products_isocheck_feature-report.svg",
                icon: "./svgs/dropdown_products_isocheck-icon.svg",
                tagLabel: "COMING SOON",
            },
            modifier: null,
        },
    ],
};
